import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import UserFieldNames from '@lib/enums/fieldNames/userFieldNames';
import getPhoneNumberPreparedDataFromValues from '@lib/utils/getPhoneNumberPreparedDataFromValues';
import { UserAssignationType } from 'components/UserForm/utils/enums';
import getItemMemberships from './getItemMemberships';

export default function getPreparedDataFromValues<T>(
  values: Values,
  prevValues: T,
) {
  const phoneNumber = getPhoneNumberPreparedDataFromValues(
    values,
    UserFieldNames.PhoneNumber,
  );
  const password = _get(values, UserFieldNames.Password);
  const assignationType = _get(values, [
    UserFieldNames.AssignationType,
    'value',
  ]);
  const siteMemberships =
    assignationType === UserAssignationType.Site
      ? getItemMemberships(values, prevValues, UserFieldNames.SiteMemberships)
      : null;
  const sectorMemberships =
    assignationType === UserAssignationType.Sector
      ? getItemMemberships(values, prevValues, UserFieldNames.SectorMemberships)
      : null;
  return {
    email: _get(values, UserFieldNames.Email),
    firstName: _get(values, UserFieldNames.FirstName),
    lastName: _get(values, UserFieldNames.LastName),
    personalId: _get(values, UserFieldNames.PersonalId),
    username: _get(values, UserFieldNames.Username),
    password: password ?? undefined,
    phoneNumber,
    role: _get(values, `${UserFieldNames.Role}.value`),
    siteMemberships,
    sectorMemberships,
    teamId: _get(values, `${UserFieldNames.Team}.value`, null),
  };
}
